import * as types from '../../actions/actionTypes';
import initialState from '../initialState';
import { _getLatestStudies } from '../../util/deUtils';

export const deImportDefReducer = (
  state = initialState.deImportDefiniton,
  action
) => {
  switch (action.type) {
    case types.RESET_DE_STUDY_DEF_STATE: {
      return {
        ...state,
        studyDefinition: {
          ...initialState.deImportDefiniton.studyDefinition,
        },
      };
    }
    case types.GET_DE_STUDY_REQUEST: {
      return {
        ...state,
        studies: {
          ...state.studies,
          defaultStudy: null,
          activeStudy: null,
          loading: true,
          error: false,
          data: [],
        },
      };
    }
    case types.GET_DE_STUDY_FAILURE: {
      return {
        ...state,
        studies: {
          ...state.studies,
          defaultStudy: null,
          activeStudy: null,
          loading: false,
          error: true,
          data: [],
        },
      };
    }
    case types.GET_DE_STUDY_SUCCESS: {
      return {
        ...state,
        studies: {
          ...state.studies,
          defaultStudy: _getLatestStudies(action.data),
          activeStudy: _getLatestStudies(action.data),
          loading: false,
          error: false,
          data: action.data,
        },
      };
    }
    case types.GET_DE_STUDY_DEF_REQUEST: {
      return {
        ...state,
        studyDefinition: {
          ...state.studyDefinition,
          studyTargets: {
            loading: true,
            error: false,
            data: [],
          },
        },
        studies: {
          ...state.studies,
          activeStudy: action.study,
        },
      };
    }
    case types.GET_DE_STUDY_DEF_FAILURE: {
      return {
        ...state,
        studyDefinition: {
          ...state.studyDefinition,
          studyTargets: {
            loading: false,
            error: true,
            data: [],
          },
        },
      };
    }
    case types.SET_DE_LATEST_STUDY_FLAG: {
      return {
        ...state,
        studies: {
          ...state.studies,
          isLatestStudy: action.isLatestStudySelected,
        },
      };
    }
    case types.GET_DE_STUDY_DEF_SUCCESS: {
      return {
        ...state,
        studyDefinition: {
          ...state.studyDefinition,
          studyTargets: {
            loading: false,
            error: false,
            data: action.data,
          },
        },
      };
    }
    case types.SET_DE_ACTIVE_STUDY_WEIGHT: {
      return {
        ...state,
        studies: {
          ...state.studies,
          activeStudy: action.activeStudy,
        },
        studyDefinition: {
          ...state.studyDefinition,
          studyTargets: {
            ...state.studyDefinition.studyTargets,
            data: action.data,
          },
        },
      };
    }
    case types.DE_RESET_IMPORT_SELECTION: {
      return {
        ...state,
        ...initialState.deImportDefiniton,
      };
    }
    case types.SET_DEFINITION_SAMPLE_WEIGHTED: {
      return {
        ...state,
        studyDefinition: {
          ...state.studyDefinition,
          available: {
            ...state.studyDefinition.available,
            [action.folderId]: action.payload,
          },
        },
      };
    }
    case types.DE_SET_DEFINITION_FOR_IMPORT: {
      return {
        ...state,
        studyDefinition: {
          ...state.studyDefinition,
          selected: {
            ...state.studyDefinition.selected,
            data: [...action.payload],
            importValidations: {
              ...state.studyDefinition.selected.importValidations,
              [action.folderId]: action.validationData,
            },
            hasSuccess: 0,
          },
        },
      };
    }
    case types.DE_EDIT_TARGETS: {
      return {
        ...state,
        studyDefinition: {
          ...state.studyDefinition,
          selected: {
            ...state.studyDefinition.selected,
            data: [...action.payload],
            importValidations: {
              ...state.studyDefinition.selected.importValidations,
              [action.folderId]: action.importValidation,
            },
            hasSuccess: 0,
          },
        },
      };
    }
    case types.DE_SAVE_TARGETS: {
      return {
        ...state,
        studyDefinition: {
          ...state.studyDefinition,
          available: action.available,
          selected: {
            ...state.studyDefinition.selected,
            data: [...action.payload],
            importValidations: action.validationData,
            hasSuccess: action.hasSuccess,
          },
        },
      };
    }
    case types.DE_IS_EDIT_TARGET_DEFINITION: {
      return {
        ...state,
        isEditTargetDefinition:action.payload,
      }
    }
    case types.DE_IS_IMPORT_TARGET_DEFINITION: {
      return {
        ...state,
        isImportClicked:action.payload,
      }
    }
    case types.SET_DE_ACTIVE_STUDY: {
      return {
        ...state,
        studies: {
          ...state.studies,
          activeStudy: action.activeStudy,
        },
      }
    }
    case types.DE_SET_ORIGINAL_TARGET_NAME: {
      return {
        ...state,
        studyDefinition: {
          ...state.studyDefinition,
          selected: {
            ...state.studyDefinition.selected,
            data: [...action.payload],
          },
        },
      };
    }
    case types.DE_SET_IMPORT_VALIDATIONS: {
      return {
        ...state,
        studyDefinition: {
          ...state.studyDefinition,
          selected: {
            ...state.studyDefinition.selected,
            importValidations: {
              ...state.studyDefinition.selected.importValidations,
              [action.folderId]: action.importValidation,
            },
          },
        },
      };
    }
    default:
      return state;
  }
};
